import { removeComma } from './convertor'

export const getLoanTerm = (pricingType: any, loanTerm: any) => {
  const match = removeComma(pricingType?.match(/\b\d+yr\b/) ?? '')
  return match ? match * 12 : removeComma(loanTerm)
}
